import React, { useState } from "react";
import { connect } from "react-redux";
import { createSkill } from "./actions";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus } from '@fortawesome/free-solid-svg-icons';

const NewSkillForm = ({ skills = [], onCreatePressed, test }) => {

    const [skill, setSkill] = useState('');
    const [performancyLevel, setPerformancyLevel] = useState('');

    return (
        <div className="border rounded bg-light p-3 m-2">
            <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 10 }}>
                <div>
                    <label htmlFor="skill" style={{ padding: '0', margin: '0' }}>Skill</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="text"
                        placeholder="Skill"
                        value={skill}
                        onChange={e => setSkill(e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="performancyLevel" style={{ padding: '0', margin: '0' }}>Performancy Level</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="number"
                        placeholder="Skill Proficiency Level"
                        value={performancyLevel}
                        min="1"
                        max="10"
                        onChange={e => setPerformancyLevel(e.target.value)}
                    />
                </div>
                <button
                    className="btn btn-success btn-sm rounded-circle"
                    disabled={skill === ''}
                    onClick={() => {
                        onCreatePressed({ skill, performancyLevel });
                        setSkill('');
                    }}
                >
                    {/* <FontAwesomeIcon icon={faPlus} /> */}
                    Add
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    skills: state.skills,
});

const mapDispatchToProps = dispatch => ({
    onCreatePressed: skill => dispatch(createSkill(skill)),


});

export default connect(mapStateToProps, mapDispatchToProps)(NewSkillForm);
